import { useState } from "react";
import { Sidebar, RightSidebar } from "../";

const MainLayout = ({ children }) => {
	const [isLeftSidebarOpen, setIsLeftSidebarOpen] = useState(false);
	const [isRightSidebarOpen, setIsRightSidebarOpen] = useState(false);

	const toggleLeftSidebar = () => {
		setIsLeftSidebarOpen((prev) => !prev);

		if (!isLeftSidebarOpen) {
			setIsRightSidebarOpen(false);
		}
	};

	const toggleRightSidebar = () => {
		setIsRightSidebarOpen((prev) => !prev);

		if (!isRightSidebarOpen) {
			setIsLeftSidebarOpen(false);
		}
	};

	return (
		<div className="app">
			<Sidebar
				isOpen={isLeftSidebarOpen}
				toggleLeftSidebar={toggleLeftSidebar}
				toggleRightSidebar={toggleRightSidebar}
			/>

			<div className="main-content">{children}</div>

			<RightSidebar isOpen={isRightSidebarOpen} />
		</div>
	);
};

export default MainLayout;
